WL.registerComponent('paper-grabbed', {
    paperMeshObject: { type: WL.Type.Object },
    grabbableObject: { type: WL.Type.Object },
}, {
    start: function () {
        this.paperMesh = this.paperMeshObject.getComponent('mesh');
        this.paperMesh.active = false;
        this.grabbable = this.grabbableObject.getComponent('grabbable');
        this.grabbable.registerGrabEventListener(this, this.onGrab.bind(this));
        this.grabbable.registerUngrabEventListener(this, this.onUngrab.bind(this));
    },
    onGrab() {
        this.paperMesh.active = true;
        this.object.resetTranslationRotation();
        this.object.rotationWorld = [0, .707, 0, .707];
        this.object.setTranslationLocal([0, 0, 0]);
        this.object.scalingWorld = [.7, .7, .7];
    },
    onUngrab() {
        this.paperMesh.active = false;        
    }

});
